<ng-container [formGroup]="parentForm">
  <div class="d-flex" style="gap: 25px">
    <mat-form-field
      appearance="outline" style="flex: grow; width: 100%;">
      <mat-label>{{label}}</mat-label>
      <input matInput
        [readonly]="parentForm.get('readonly').value"
        formControlName="name">
      </mat-form-field>

      @if (!parentForm.get('readonly').value) {
        <odq-date-input
          formControlName="startDate"
          [placeholder]="'legalEntityAnnualDeclaration.startDate' | translate"
          [clearable]="false"
          badge="5"
          helpTopicBadge style="flex: auto">
        </odq-date-input>
      }
      @if (!!parentForm.get('endDate').value) {
        <odq-date-input
          formControlName="endDate"
          [placeholder]="'legalEntityAnnualDeclaration.endDate' | translate"
          badge="7"
          helpTopicBadge style="flex: auto">
        </odq-date-input>
      }
    </div>
  </ng-container>